(function() {
  var form = document.getElementById('footer-newsletter-form');
  if (!form) return;

  // Initialize Turnstile widget and get its ID
  let widgetId = null;
  let submitting = false;
  var submitBtn = form.querySelector('button[type="submit"]');

  const waitTurnstile = function() {
    return new Promise((resolve, reject) => {
      function check() {
        if (!!window.turnstile) {
          return resolve(true);
        } else {
          setTimeout(check, 100);
        }
      }
      check();
    });
  };

  async function initTurnstile() {
    submitBtn.disabled = true;
    await waitTurnstile();

    widgetId = turnstile.render("#footer-newsletter-turnstile", {
      sitekey: "0x4AAAAAACObTdbrbFtMbrfQ",
      theme: "light",
      callback: function() {
        submitBtn.disabled = false;
      },
      "expired-callback": function () {
        // Token expired - reset widget to get new token
        if (widgetId !== null) {
          turnstile.reset(widgetId);
        }
      },
    });
  }

  initTurnstile();

  var emailInput = document.getElementById('footer-newsletter-email');
  var aiDetectInput = document.getElementById('footer-newsletter-ai-detect');
  var successMessage = document.getElementById('footer-newsletter-message');
  var errorMessage = document.getElementById('footer-newsletter-message-error');

  function hideFormControls() {
    emailInput.setAttribute('data-visible', 'false');
    submitBtn.setAttribute('data-visible', 'false');
  }

  function showSuccess() {
    hideFormControls();
    successMessage.setAttribute('data-visible', 'true');
    errorMessage.setAttribute('data-visible', 'false');
  }

  function showError() {
    hideFormControls();
    errorMessage.setAttribute('data-visible', 'true');
    successMessage.setAttribute('data-visible', 'false');
  }

  form.addEventListener('submit', async function(e) {
    e.preventDefault();

    if (submitting) return;
    submitting = true;

    var csrfToken = document.querySelector('[name="CRAFT_CSRF_TOKEN"]');
    var email = emailInput.value.trim();
    if (!email) return;

    // Honeypot check - if filled, it's likely a bot
    var honeypotValue = aiDetectInput.value.trim();
    if (honeypotValue) {
      // Silently ignore bot submissions
      return;
    }

    // Get Turnstile token from specific widget
    var turnstileToken = turnstile.getResponse(widgetId);
    if (!turnstileToken) {
      showError();
      return;
    }

    var originalText = submitBtn.textContent;
    submitBtn.textContent = 'SENDING...';
    submitBtn.disabled = true;

    fetch('/actions/businesslogic/hubspot/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': csrfToken && csrfToken.value || ''
      },
      body: new URLSearchParams({
        email: email,
        'cf-turnstile-response': turnstileToken,
        'pageUri': window.location.href,
        'pageName': document.title
      })
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      if (data.success) {
        showSuccess();
      } else {
        throw new Error(data.message || 'Subscription failed');
      }
    })
    .catch(function() {
      showError();
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
      // Reset Turnstile widget on error (reset only this specific widget)
      if (widgetId) {
        turnstile.reset(widgetId);
      }
    })
    .finally(function() {
      submitting = false;
    });
  });
})();
